import { InjectionToken } from '@angular/core';

/**
 * Base URL for sitemanager. Apps provide it from their environment file (e.g.
 * `https://api.dev.wheere.tech/sitemanager`). Mirrors the BASE_PATH token pattern of the
 * generated `@wheere/api-site` client so this lib can swap between hand-written calls and the
 * generated client without consumer changes.
 */
export const SITEMANAGER_BASE_PATH = new InjectionToken<string>('SITEMANAGER_BASE_PATH');
